<template>
  <div class="nav" tabindex="1" tabName="navbar">
    <router-link :to="{ path: '/', query: $route.query }" class="nav__item" tabIndex="-1"
      :class="{ 'nav__item--active': activeOnPage == '' }" @click.native.stop="() => activePage('')">{{
        getTranslatedText(`next up`) }}</router-link>

    <router-link :to="{ path: '/racing', query: $route.query }" class="nav__item" tabIndex="-1"
      :class="{ 'nav__item--active': activeOnPage == 'racing' }" @click.native.stop="() => activePage('racing')">{{
        getTranslatedText(`today racing`) }}</router-link>

    <router-link :to="{ path: '/result', query: $route.query }" class="nav__item" tabIndex="-1"
      :class="{ 'nav__item--active': activeOnPage == 'result' }" @click.native.stop="() => activePage('result')">{{
        getTranslatedText(`today result`) }}</router-link>

    <router-link :to="{ path: '/history', query: $route.query }" class="nav__item" tabIndex="-1"
      :class="{ 'nav__item--active': activeOnPage == 'history' }" @click.native.stop="() => activePage('history')">{{
        getTranslatedText(`history`) }}</router-link>
  </div>
</template>
<script>
import languageMixins from "@/mixins/language/language-mixins";
import Page from "@/models/enums/page";
import EventBus from "@/utils/EventBus";

export default {
  mixins: [languageMixins],
  data() {
    return {
      activeOnPage: Page.Nextup,
    };
  },
  created() {
    // get url
    const path = this.$route.path.split("/");
    const page = path[1];
    this.redirectPage(page);
  },

  mounted() {
    this.$parent.$on("refreshNavbar", this.refreshNavbar);
    EventBus.$on("change-active-page", this.changeActivePage)
  },
  beforeUnmount() {
    this.$parent.$off("refreshNavbar");
    EventBus.$off("change-active-page")
  },

  methods: {
    activePage(page) {
      this.redirectPage(page);
    },

    redirectPage(page) {
      if (page == Page.Today) {
        this.activeOnPage = Page.Today;
      } else if (page == Page.Result) {
        this.activeOnPage = Page.Result;
      } else if (page == Page.History) {
        this.activeOnPage = Page.History;
      } else {
        this.activeOnPage = Page.Nextup;
      }
    },

    refreshNavbar() {
      this.$forceUpdate();
    },

    changeActivePage(page) {
      this.redirectPage(page)
    }
  },
};
</script>

<style lang="scss">
@import "@/public/scss/components/navbar.scss";
</style>
